<div class="main-content">
  <div *ngIf="canRead()">

    <!-- ─── HEADER: titolo | utente e sezioni danni | strumentario (stesso design delle altre pagine danni) ─── -->
    <div class="header-section">
      <div class="wm-heading">
        <div class="wm-heading-icon wm-heading-icon--orange">
          <i class="fas fa-house-damage"></i>
        </div>
        <div>
          <h1 class="main-title">Gestione Danni</h1>
          <p class="main-subtitle">Resoconto di pratiche, colli danneggiati e importi</p>
        </div>
      </div>

      <!-- Utente collegato e collegamenti alle pagine della gestione danni -->
      <app-damage-nav-box #navBox></app-damage-nav-box>

      <!-- Strumentario -->
      <div class="toolbox-container">
        <div class="toolbox-heading">
          <div class="toolbox-heading-icon">
            <i class="fas fa-tools"></i>
          </div>
          <div class="toolbox-heading-text">
            <span class="toolbox-title">Strumentario</span>
            <small class="toolbox-subtitle">Strumenti rapidi</small>
          </div>
        </div>
        <div class="toolbox-divider"></div>
        <div class="toolbox-buttons">

          <!-- Aggiorna dati -->
          <button type="button" class="toolbox-btn toolbox-btn--green" (click)="refreshData()"
                  [disabled]="isLoadingReport"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  data-bs-title="Aggiorna i dati (ricalcola il resoconto con le date correnti)">
            <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingReport"></i>
          </button>

          <!-- Comprimi/Espandi sezioni -->
          <button type="button" class="toolbox-btn toolbox-btn--purple" (click)="toggleAllSections()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  data-bs-title="Comprimi/Espandi tutte le sezioni">
            <i class="fas" [ngClass]="areAllSectionsCollapsed ? 'fa-expand-alt' : 'fa-compress-alt'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ─── SEZIONE RESOCONTO ─── -->
    <div id="report-section" class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-chart-pie header-icon"></i>
            <h3>Resoconto</h3>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleReportCollapsed()"
                  [title]="isReportCollapsed ? 'Espandi' : 'Comprimi'">
            <i class="fas" [ngClass]="isReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
      <div class="card-body" *ngIf="!isReportCollapsed">

        <!-- Filtri periodo -->
        <div class="row g-3 align-items-end mb-4">
          <div class="col-md-4">
            <label class="form-label">Data da</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-plus filter-icon"></i>
              <input type="text"
                     class="filter-input"
                     #reportDateFromInput
                     placeholder="Seleziona data/ora inizio"
                     readonly>
              <button type="button" class="filter-clear-btn"
                      *ngIf="reportDateFrom"
                      (click)="clearReportDate('from')"
                      title="Cancella data inizio">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label">Data a</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-minus filter-icon"></i>
              <input type="text"
                     class="filter-input"
                     #reportDateToInput
                     placeholder="Seleziona data/ora fine"
                     readonly>
              <button type="button" class="filter-clear-btn"
                      *ngIf="reportDateTo"
                      (click)="clearReportDate('to')"
                      title="Cancella data fine">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div class="col-md-4 d-flex justify-content-end gap-2">
            <button class="btn btn-outline-secondary btn-sm" type="button"
                    (click)="resetReportPeriod()"
                    title="Cancella le date (ricerca aperta)">
              <i class="fas fa-undo me-1"></i>
              Reset
            </button>
            <button class="btn btn-primary btn-sm" type="button"
                    (click)="loadReport()"
                    [disabled]="isLoadingReport || !isReportPeriodValid"
                    title="Calcola il resoconto">
              <i class="fas" [ngClass]="{ 'fa-spinner fa-spin': isLoadingReport, 'fa-search': !isLoadingReport }" [class.me-1]="true"></i>
              Calcola
            </button>
          </div>
        </div>

        <!-- Periodo non valido -->
        <div *ngIf="!isReportPeriodValid" class="alert alert-warning py-2 mb-4">
          <i class="fas fa-exclamation-triangle me-2"></i>
          La data di fine deve essere successiva alla data di inizio.
        </div>

        <!-- Richiesta del resoconto fallita -->
        <div *ngIf="!isLoadingReport && reportLoadError" class="alert alert-danger py-2 mb-4">
          <i class="fas fa-exclamation-circle me-2"></i>
          Resoconto non disponibile: la richiesta al server non è andata a buon fine. I totali sono a zero.
        </div>

        <!-- Totali -->
        <div class="d-flex align-items-center mb-3">
          <span class="text-uppercase fw-semibold text-muted small letter-spacing-1">Totali del periodo</span>
          <div class="flex-grow-1 ms-3 border-bottom"></div>
        </div>
        <!-- Una sola card, tre sezioni affiancate (Pratiche danno, Colli danneggiati, Importi):
             ciascuna con totale e lista di statistiche su due colonne -->
        <div class="dmh-totals-card mb-4">

          <!-- Skeleton: stessa struttura delle sezioni reali, finché i dati non arrivano -->
          <ng-container *ngIf="isLoadingReport">
            <div class="dmh-totals-section dmh-totals-section--skeleton" *ngFor="let _ of skeletonSections" aria-hidden="true">
              <div class="dmh-totals-header">
                <div class="dmh-skeleton dmh-skeleton-icon"></div>
                <div class="dmh-totals-heading">
                  <span class="dmh-skeleton dmh-skeleton-title"></span>
                  <span class="dmh-skeleton dmh-skeleton-subtitle"></span>
                </div>
                <span class="dmh-skeleton dmh-skeleton-total"></span>
              </div>

              <div class="dmh-totals-list">
                <div class="dmh-stat-row dmh-stat-row--skeleton" *ngFor="let _ of skeletonStatRows">
                  <span class="dmh-skeleton dmh-skeleton-dot"></span>
                  <span class="dmh-stat-label"><span class="dmh-skeleton dmh-skeleton-line"></span></span>
                  <span class="dmh-skeleton dmh-skeleton-value"></span>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!isLoadingReport">
            <div class="dmh-totals-section" *ngFor="let section of totalsSections">
              <div class="dmh-totals-header">
                <div class="dmg-metric-icon" [ngClass]="'dmg-metric-icon--' + section.tone">
                  <i class="fas" [ngClass]="section.icon"></i>
                </div>
                <div class="dmh-totals-heading">
                  <span class="dmh-totals-title">{{ section.label }}</span>
                  <span class="dmh-totals-subtitle">nel periodo</span>
                </div>
                <span class="dmh-totals-total" [ngClass]="'dmh-totals-total--' + section.tone">
                  {{ section.total | number }}
                </span>
              </div>

              <div class="dmh-totals-list">
                <div class="dmh-stat-row" *ngFor="let stat of section.stats" [title]="stat.title || ''">
                  <span class="dmh-stat-dot" *ngIf="stat.color" [style.background]="stat.color"></span>
                  <i class="fas dmh-stat-icon" *ngIf="stat.icon" [ngClass]="stat.icon"></i>
                  <span class="dmh-stat-label">{{ stat.label }}</span>
                  <span class="dmh-stat-value">{{ stat.value }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Grafici -->
        <div class="d-flex align-items-center mb-3">
          <span class="text-uppercase fw-semibold text-muted small letter-spacing-1">Grafici</span>
          <div class="flex-grow-1 ms-3 border-bottom"></div>
        </div>
        <div class="dmh-charts-grid">

          <!-- Andamento giornaliero -->
          <div class="dmh-chart-card dmh-chart-card--wide">
            <div class="dmh-chart-toolbar">
              <div class="dmh-chart-title mb-0">
                <i class="fas fa-chart-bar"></i> Andamento giornaliero
                <span class="dmh-chart-title-hint" *ngIf="isTrendPeriodOpen">
                  (finestre di {{ trendWindowSize }} giorni)
                </span>
                <span class="dmh-chart-title-hint" *ngIf="!isTrendPeriodOpen && hasTrendPaging">
                  (max {{ trendWindowSize }} giorni su {{ trendTotalDays }})
                </span>
              </div>

              <div class="dmh-chart-controls">
                <!-- Giorni per finestra: 7 / 15 / 21 / 30 / 60 / 90 -->
                <div class="btn-group btn-group-sm chart-type-selector window-size-selector" role="group" aria-label="Giorni per finestra">
                  <button *ngFor="let size of trendWindowSizes"
                          type="button"
                          class="btn"
                          [ngClass]="trendWindowSize === size ? 'btn-secondary' : 'btn-outline-secondary'"
                          (click)="setTrendWindowSize(size)"
                          [title]="'Finestre di ' + size + ' giorni'">
                    {{ size }}g
                  </button>
                </div>

                <!-- Finestra di visualizzazione: < > quando c'è un'altra finestra (sempre, con la ricerca aperta) -->
                <div class="dmh-trend-pager" *ngIf="hasTrendPaging" role="group" aria-label="Finestra di visualizzazione">
                  <button type="button" class="dmh-trend-pager-btn"
                          (click)="shiftTrendWindow(-1)"
                          [disabled]="!canTrendPrev"
                          [title]="trendWindowSize + ' giorni precedenti'">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <span class="dmh-trend-pager-label">
                    {{ trendWindowLabel }}
                    <!-- Torna alla finestra con il giorno attuale -->
                    <button type="button" class="dmh-trend-today-btn"
                            (click)="goToCurrentTrendWindow()"
                            [disabled]="!isTodayInTrendPeriod || isTodayInTrendWindow"
                            [title]="!isTodayInTrendPeriod ? 'Oggi è fuori dal periodo selezionato'
                                   : isTodayInTrendWindow ? 'La finestra contiene già oggi'
                                   : 'Torna alla finestra con il giorno attuale'">
                      <i class="fas fa-calendar-day"></i>
                    </button>
                  </span>
                  <button type="button" class="dmh-trend-pager-btn"
                          (click)="shiftTrendWindow(1)"
                          [disabled]="!canTrendNext"
                          [title]="trendWindowSize + ' giorni successivi'">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>

                <!-- Serie visualizzate -->
                <div class="dmh-series-toggles" role="group" aria-label="Serie visualizzate">
                  <button *ngFor="let s of trendSeries"
                          type="button"
                          class="dmh-series-chip"
                          [class.active]="trendSeriesVisible[s.key]"
                          [style.--chip-color]="s.color"
                          [attr.aria-pressed]="trendSeriesVisible[s.key]"
                          (click)="toggleTrendSeries(s.key)"
                          [title]="(trendSeriesVisible[s.key] ? 'Nascondi ' : 'Mostra ') + s.label">
                    <span class="dmh-series-dot"></span>
                    {{ s.label }}
                  </button>
                </div>

                <!-- Tipo di grafico -->
                <div class="btn-group btn-group-sm chart-type-selector" role="group" aria-label="Tipo di grafico">
                  <button *ngFor="let t of trendChartTypes"
                          type="button"
                          class="btn"
                          [ngClass]="trendChartType === t.key ? 'btn-secondary' : 'btn-outline-secondary'"
                          (click)="setTrendChartType(t.key)"
                          [title]="t.label">
                    <i class="fas" [ngClass]="t.icon"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="dmh-chart-body">
              <!-- Skeleton: barre di altezza variabile finché i dati non arrivano -->
              <div *ngIf="isLoadingTrend" class="dmh-skeleton-chart dmh-skeleton-chart--bars" aria-hidden="true">
                <div class="dmh-skeleton-bars">
                  <span class="dmh-skeleton dmh-skeleton-bar" *ngFor="let h of skeletonBars" [style.height.%]="h"></span>
                </div>
                <span class="dmh-skeleton dmh-skeleton-axis"></span>
              </div>
              <canvas *ngIf="!isLoadingTrend && hasTrendData && hasVisibleTrendSeries"
                      baseChart
                      [type]="trendBaseType"
                      [data]="trendChartData"
                      [options]="trendChartOptions">
              </canvas>
              <!-- Richiesta a /damaged-parcels/graphics fallita per la finestra corrente -->
              <div *ngIf="!isLoadingTrend && !hasTrendData" class="empty-section h-100">
                <i class="fas fa-chart-bar"></i>
                <span>Andamento giornaliero non disponibile</span>
              </div>
              <div *ngIf="!isLoadingTrend && hasTrendData && !hasVisibleTrendSeries" class="empty-section h-100">
                <i class="fas fa-eye-slash"></i>
                <span>Seleziona almeno una serie da visualizzare</span>
              </div>
            </div>
          </div>

          <!-- Torta pratiche per stato -->
          <div class="dmh-chart-card">
            <div class="dmh-chart-title"><i class="fas fa-folder-open"></i> Pratiche per stato</div>
            <div class="dmh-chart-body">
              <ng-container *ngIf="isLoadingReport" [ngTemplateOutlet]="pieSkeleton"></ng-container>
              <canvas *ngIf="!isLoadingReport && report.claims.total > 0"
                      baseChart
                      type="doughnut"
                      [data]="claimsPieData"
                      [options]="pieChartOptions"
                      [plugins]="pieChartPlugins">
              </canvas>
              <div *ngIf="!isLoadingReport && report.claims.total === 0" class="empty-section h-100">
                <i class="fas fa-chart-pie"></i>
                <span>Nessuna pratica nel periodo</span>
              </div>
            </div>
          </div>

          <!-- Torta colli danneggiati per pratica -->
          <div class="dmh-chart-card">
            <div class="dmh-chart-title"><i class="fas fa-hammer"></i> Colli danneggiati per pratica</div>
            <div class="dmh-chart-body">
              <ng-container *ngIf="isLoadingReport" [ngTemplateOutlet]="pieSkeleton"></ng-container>
              <canvas *ngIf="!isLoadingReport && report.parcels.total > 0"
                      baseChart
                      type="doughnut"
                      [data]="parcelsPieData"
                      [options]="pieChartOptions"
                      [plugins]="pieChartPlugins">
              </canvas>
              <div *ngIf="!isLoadingReport && report.parcels.total === 0" class="empty-section h-100">
                <i class="fas fa-chart-pie"></i>
                <span>Nessun collo danneggiato nel periodo</span>
              </div>
            </div>
          </div>

          <!-- Torta importi per stato -->
          <div class="dmh-chart-card">
            <div class="dmh-chart-title"><i class="fas fa-euro-sign"></i> Importi per stato</div>
            <div class="dmh-chart-body">
              <ng-container *ngIf="isLoadingReport" [ngTemplateOutlet]="pieSkeleton"></ng-container>
              <canvas *ngIf="!isLoadingReport && report.amounts.total > 0"
                      baseChart
                      type="doughnut"
                      [data]="amountsPieData"
                      [options]="pieChartOptions"
                      [plugins]="pieChartPlugins">
              </canvas>
              <div *ngIf="!isLoadingReport && report.amounts.total === 0" class="empty-section h-100">
                <i class="fas fa-chart-pie"></i>
                <span>Nessun importo nel periodo</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Skeleton delle torte: anello + legenda, condiviso dalle tre card -->
        <ng-template #pieSkeleton>
          <div class="dmh-skeleton-chart dmh-skeleton-chart--pie" aria-hidden="true">
            <span class="dmh-skeleton-ring"></span>
            <div class="dmh-skeleton-legend">
              <span class="dmh-skeleton dmh-skeleton-legend-item"></span>
              <span class="dmh-skeleton dmh-skeleton-legend-item"></span>
              <span class="dmh-skeleton dmh-skeleton-legend-item"></span>
              <span class="dmh-skeleton dmh-skeleton-legend-item"></span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- ─── SEZIONE FUNZIONALITÀ ─── -->
    <!-- Stessa griglia di card di /otm-management (dmh-features-grid / dmh-feature-card):
         al momento nessuna funzionalità è disponibile, resta il segnaposto -->
    <div id="features-section" class="card mb-4">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <div class="header-title">
            <i class="fas fa-th-large header-icon"></i>
            <h3>Funzionalità</h3>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleFeaturesCollapsed()"
                  [title]="isFeaturesCollapsed ? 'Espandi' : 'Comprimi'">
            <i class="fas" [ngClass]="isFeaturesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
          </button>
        </div>
      </div>
      <div class="card-body" *ngIf="!isFeaturesCollapsed">
        <div class="empty-section">
          <i class="fas fa-th-large"></i>
          <span>Nessuna funzionalità disponibile al momento</span>
        </div>
      </div>
    </div>

  </div>

  <!-- Messaggio permessi insufficienti -->
  <div *ngIf="!canRead()" class="alert alert-warning">
    <i class="fas fa-exclamation-triangle me-2"></i>
    Non hai i permessi necessari per visualizzare questa pagina.
  </div>
</div>
